import { computed } from 'vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { useAccount } from './useAccount';

export function usePortalsQuota() {
  const { currentAccount, isCloudFeatureEnabled } = useAccount();

  const helpCenterEnabled = computed(() =>
    isCloudFeatureEnabled(FEATURE_FLAGS.HELP_CENTER)
  );

  const remaining = computed(() => {
    const dim = currentAccount.value?.limits?.portals;
    if (!dim || dim.allowed == null) return null;
    const value = dim.remaining ?? dim.allowed - (dim.consumed ?? 0);
    return Math.max(0, value);
  });

  const portalsQuotaExhausted = computed(() => remaining.value === 0);

  const canAddPortals = computed(
    () => helpCenterEnabled.value && remaining.value !== 0
  );

  return {
    remaining,
    portalsQuotaExhausted,
    canAddPortals,
  };
}
